import { useState } from "react";
import { cn } from "../../lib/cn";

/**
 * PlayerHead / Avatar — tête MC rendue via un service public (mc-heads / Crafatar)
 * par uuid ou pseudo. Cadre laiton, fallback initiales si l'image échoue.
 */

interface PlayerHeadProps {
  /** uuid (sans tirets accepté) OU pseudo. */
  uuid?: string | null;
  name?: string | null;
  size?: number;
  rounded?: boolean;
  className?: string;
  overlay?: boolean;
}

/** Fournit l'URL d'un rendu de tête (3D helm) depuis mc-heads.net. */
export function playerHeadUrl(idOrName: string, size = 64): string {
  const id = encodeURIComponent(idOrName.replace(/-/g, ""));
  return `https://mc-heads.net/avatar/${id}/${size}`;
}

export function PlayerHead({
  uuid,
  name,
  size = 40,
  rounded = false,
  className,
  overlay = true,
}: PlayerHeadProps) {
  const [errored, setErrored] = useState(false);
  const id = uuid || name || "";
  const initials = (name ?? "?").slice(0, 2).toUpperCase();

  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center overflow-hidden border border-bronze-500/50 bg-obsidian-100",
        rounded ? "rounded-full" : "rounded-md",
        overlay && "shadow-rivet",
        className,
      )}
      style={{ width: size, height: size }}
    >
      {id && !errored ? (
        <img
          src={playerHeadUrl(id, Math.min(256, Math.max(32, size * 2)))}
          alt={name ? `Tête de ${name}` : "Tête du joueur"}
          width={size}
          height={size}
          loading="lazy"
          onError={() => setErrored(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        <span className="font-display text-xs font-bold text-parchment-200/70">{initials}</span>
      )}
    </span>
  );
}
